<template>
	<div>
		<modalconfirm ref="modalconfirmAddRetail" @action="proccessRetail"/>
		<div class="text-h5">Tambah Penjualan Karyawan</div>
		<v-card class="mt-3" outlined>
			<v-form ref="formSRE" role="form" v-on:submit.prevent="addSales">
				<v-card-text class="pt-2">
					<v-alert v-for="(alert, index) in alertMultiple" v-model="alert.show" :key="index" dismissible type="error" elevation="1">
						{{alert.message}}
					</v-alert>
					<v-row>
						<v-col cols="12" sm="4" md="4">
							<v-row>
								<v-col cols="12" class="py-0">
									<v-text-field v-model="nip" :rules="[inputrules.required]" label="No. Induk Pegawai" @focus="() => responseError.nip=''" :error-messages="responseError.nip" outlined dense @input="toUpper"></v-text-field>
								</v-col>
								<v-col cols="12" class="py-0">
									<v-textarea v-model="address" label="Alamat" :rules="[inputrules.required]" @focus="() => responseError.address=''" :error-messages="responseError.address" rows="2" height="80" hide-details="auto" outlined dense no-resize></v-textarea>
								</v-col>
							</v-row>
						</v-col>
						<v-col cols="12" sm="4" md="4">
							<v-row>
								<v-col cols="12" class="py-0">
									<v-text-field v-model="name" label="Nama Karyawan" :rules="[inputrules.required]" @focus="() => responseError.name=''" :error-messages="responseError.name" outlined dense></v-text-field>
								</v-col>
								<v-col cols="12" class="py-0">
									<v-textarea v-model="sre_note" label="Catatan" rows="4" height="80" @focus="() => responseError.note=''" :error-messages="responseError.note" hide-details="auto" outlined dense no-resize></v-textarea>
								</v-col>
							</v-row>
						</v-col>
						<v-col cols="12" sm="4" md="4">
							<v-row>
								<v-col cols="12" class="py-0">
									<v-text-field v-model="mobilephone" @keydown="onlyNumber" label="No. Handphone" @focus="() => responseError.mobilephone=''" :error-messages="responseError.mobilephone" outlined dense></v-text-field>
								</v-col>
								<v-col cols="12" class="py-0">
									<v-currency-field v-model="discount_percentage" label="Diskon (%)" :max="100" class="py-2 details-mb-0" outlined dense hide-details="auto" background-color="white" @focus="() => responseError.discount_percentage=''" :error-messages="responseError.discount_percentage" :decimalLength="2"></v-currency-field>
								</v-col>
							</v-row>
						</v-col>
						<v-col cols="12">
							<v-alert v-if="responseError.product" color="red lighten-4 pink--text text-body-2">
								<v-icon class="mt-n1" color="pink">mdi-alert-circle-outline</v-icon>
								<span class="pl-2">{{responseError.product}}</span>
							</v-alert>
							<v-simple-table class="white-row" no-data-text="Belum ada data tersedia">
								<template v-slot:default>
									<thead class="v-data-table-header">
										<tr>
											<th width="5%" class="text-left">Aksi</th>
											<th width="25%" class="text-left">Nama Produk</th>
											<th width="10%" class="text-right">Harga Produk (Rp)</th>
											<th width="10%" class="text-left">Jumlah</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="(product, index) in productsSelected" :key="product.product_id">
											<td>
												<v-tooltip bottom>
													<template v-slot:activator="{ on, attrs }">
														<v-btn class="" fab dark x-small depressed color="pink" v-bind="attrs" v-on="on" @click.stop="deletefromRetail(index)">
															<v-icon dark>mdi-delete</v-icon>
														</v-btn>
													</template>
													<span>Hapus</span>
												</v-tooltip>
											</td>
											<td>
												<v-autocomplete :items="productsNotSelected" :filter="customFilter" return-object item-text="product_name" v-model="product.data" no-data-text="Tidak ada data yang sesuai" :rules="[productRules]" class="py-2 details-mb-0" outlined dense hide-details="auto" background-color="white">
													<template v-slot:item = {item}>
														{{item.product_code}} - {{item.product_name}} ({{item.product_unit}})
													</template>
													<template v-slot:selection = {item}>
														{{item.product_name}}
													</template>
												</v-autocomplete>
											</td>
											<td class="text-right"> {{ product.data.price ? product.data.price : 0 | toNumber }} </td>
											<td>
												<v-currency-field v-model="product.data.quantity" :rules="[inputrules.required, inputrules.notnull]" class="py-2 details-mb-0" outlined dense hide-details="auto" background-color="white"></v-currency-field>
											</td>
										</tr>
									</tbody>
									<tfoot v-if="grandTotal > 0">
										<tr>
											<td colspan="2"></td>
											<td colspan="1">
												<div class="font-weight-bold">Subtotal</div>
											</td>
											<td colspan="1">
												<div class="font-weight-bold text-right">{{ grandTotal | toRupiah }}</div>
											</td>
										</tr>
										<tr>
											<td colspan="2"></td>
											<td colspan="1">
												<div class="font-weight-bold">Total Diskon</div>
											</td>
											<td colspan="1">
												<div class="font-weight-bold text-right">{{ discountTotal | toRupiah }}</div>
											</td>
										</tr>
										<tr>
											<td colspan="2"></td>
											<td colspan="1">
												<div class="font-weight-bold">Total Harga</div>
											</td>
											<td colspan="1">
												<div class="font-weight-bold text-right">{{ grandTotal - discountTotal | toRupiah }}</div>
											</td>
										</tr>
										<tr>
											<td colspan="2"></td>
											<td colspan="1">
												<div class="font-weight-bold">Potongan Harga</div>
											</td>
											<td colspan="1">
												<div class="font-weight-bold text-right">
													<v-currency-field v-model="rebate_value" :allow-negative="false" :max="discount_percentage > 100 ? 0 : grandTotal - discountTotal" reverse suffix="Rp " class="py-2 details-mb-0" outlined dense hide-details="auto" background-color="white"></v-currency-field>
												</div>
											</td>
										</tr>
										<tr>
											<td colspan="2"></td>
											<td colspan="1">
												<div class="font-weight-bold">Total Bayar</div>
											</td>
											<td colspan="1">
												<div class="font-weight-bold text-right">{{ (grandTotal - discountTotal - rebate_value) | toRupiah }}</div>
											</td>
										</tr>
									</tfoot>
								</template>
							</v-simple-table>
						</v-col>
						<v-col cols="12" class="pt-0">
							<v-btn light depressed color="primary" @click="addProduct">
								<v-icon>mdi-plus-circle</v-icon>
								<div class="pl-2 text-capitalize">Tambah Produk</div>
							</v-btn>
						</v-col>
						<v-col cols="12">
							<v-alert dense text type="error" elevation="0" v-if="responseError.payment">
								<div class="text-body-2">{{responseError.payment}}</div>
							</v-alert>
							<v-simple-table class="white-row" no-data-text="Belum ada data tersedia">
								<template v-slot:default>
									<thead class="v-data-table-header">
										<tr>
											<th width="5%" class="text-left">Aksi</th>
											<th width="30%" class="text-left">Pembayaran</th>
											<th width="20%" class="text-left">Nominal</th>
											<th width="45%" class="text-left">Catatan</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="(payment, index) in paymentSelected" :key="index">
											<td>
												<v-tooltip bottom>
													<template v-slot:activator="{ on, attrs }">
														<v-btn fab dark x-small depressed color="pink" v-bind="attrs" v-on="on" @click.stop="deletePaymentSO(index)">
															<v-icon dark>mdi-delete</v-icon>
														</v-btn>
													</template>
													<span>Hapus</span>
												</v-tooltip>
											</td>
											<td>
												<v-autocomplete @input="selectPayment($event, index)" :items="paymentsNotSelected" return-object item-text="text" placeholder="Pilih Tipe Pembayaran" no-data-text="Tidak ada data yang sesuai" :rules="[paymentRules]" class="py-2 details-mb-0 width-0" outlined dense hide-details="auto" background-color="white">
												</v-autocomplete>
											</td>
											<td>
												<v-currency-field v-model="payment.data.payment_value" :rules="[inputrules.required]" placeholder="Nominal" class="py-2 details-mb-0" outlined dense hide-details="auto" background-color="white"></v-currency-field>
											</td>
											<td>
												<v-text-field v-model="payment.data.payment_note" placeholder="Catatan" class="py-2 details-mb-0" outlined dense hide-details="auto" background-color="white"></v-text-field>
											</td>
										</tr>
									</tbody>
									<tfoot>
										<tr v-if="productsSelected.length > 0">
											<td colspan="6">
												<div class="d-flex justify-end pt-3">
													<div class="font-weight-bold text-right px-4">Total Dibayarkan</div>
													<div class="font-weight-bold text-right">{{ grandTotalPayment | toRupiah }}</div>
												</div>
											</td>
										</tr>
									</tfoot>
								</template>
							</v-simple-table>
						</v-col>
						<v-col cols="12" class="pt-0">
							<v-btn light depressed color="primary" @click="addPayment">
								<v-icon>mdi-plus-circle</v-icon>
								<div class="pl-2 text-capitalize">Tambah Pembayaran</div>
							</v-btn>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions class="px-4 pb-4">
					<v-spacer></v-spacer>
					<v-btn color="primary darken-1" depressed class="text-capitalize" type="submit">Proses</v-btn>
				</v-card-actions>
			</v-form>
		</v-card>
	</div>
</template>

<script>

import {mapActions, mapState, mapMutations} from 'vuex'

export default {
	inject: ['theme'],
	components: {
	},
	data() {
		return {
			nip: '',
			name: '',
			address: '',
			mobilephone: '',
			productsSelected: [],
			paymentSelected: [],
			sre_note: '',
			discount_percentage: 0,
			rebate_value: null,
			productRules: value => !!value.product_id || 'Tidak boleh kosong',
			paymentRules: value => !!value.code || 'Tidak boleh kosong',
			product_name: '',
			product_id: '',
			isLoading: false,
		}
	},
	computed: {
		...mapState('sre', ['listProduct', 'response', 'responseError', 'OptionPaymentMethod', 'alertMultiple']),

		paymentsNotSelected() {
			if (this.paymentSelected.length > 0) {
				const paymentSelected = this.paymentSelected.map((el) => el.data)
				return this.OptionPaymentMethod.map((el) => {
					if (paymentSelected.includes(el)) {
						el.disabled = true
					} else {
						el.disabled = false
					}
					return el
				})
			}
			return this.OptionPaymentMethod
		},
		grandTotalPayment(){
			let total = 0
			this.paymentSelected.forEach( (el) => {
				let price = el.data.payment_value ? el.data.payment_value : 0
				total += price
			});

			return total
		},
		productsNotSelected() {
			if (this.productsSelected.length > 0) {
				const selectedProduct = this.productsSelected.map((el) => el.data)
				return this.listProduct.map((el) => {
					if (selectedProduct.includes(el)) {
						el.disabled = true
					} else {
						el.disabled = false
					}
					return el
				})
			}
			return this.listProduct
		},
		grandTotal(){
			let total = 0
			this.productsSelected.forEach( (el) => {
				let price = el.data.price ? el.data.price : 0
				let quantity = el.data.quantity ? el.data.quantity : 0
				total += price * quantity
			});

			return total
		},		
		discountTotal() {
			return parseInt(this.discount_percentage * this.grandTotal / 100)
		},
	},
	methods: {
		...mapActions('sre', ['createSRE', 'getOptionProduct', 'getOptionPaymentMethod', 'success']),
		...mapMutations('sre', ['saveResponse', 'clearDataSRE']),
		...mapMutations(['setSnackbar', 'setOverlay']),

		customFilter (item, queryText) {
			const textOne = item.product_code.toString().toLowerCase()
			const textTwo = item.product_name.toString().toLowerCase()
			const searchText = queryText.toLowerCase()

			return textOne.indexOf(searchText) > -1 ||
			textTwo.indexOf(searchText) > -1
		},
		toUpper(el) {
			this.nip = el.toUpperCase()
		},
		addProduct() {
			this.responseError.product = ''
			this.productsSelected.push({
				data: {
					product_id: '',
					product_name: '',
					quantity: '0',
				},
			})
		},
		deletefromRetail(index){
			this.productsSelected.splice(index, 1)
		},
		addPayment() {
			this.responseError.payment = ''
			this.paymentSelected.push({
				data: {
					code: "",
					text: "",
					payment_note: "",
					payment_value: 0,
				},
			})
		},
		selectPayment(value, index) {
			this.paymentSelected[index].data = Object.assign({}, value)
		},
		deletePaymentSO(index){
			this.paymentSelected.splice(index, 1)
		},
		checkPaymentValue() {
			return new Promise((resolve, reject) => {
				let totalPayment = 0
				this.paymentSelected.forEach( el => {
					if (el.data.payment_value) {
						totalPayment += el.data.payment_value
					}
				})

				let totalProductPrice = 0
				this.productsSelected.forEach( (el) => {
					totalProductPrice += el.data.quantity * el.data.price
				})

				if (totalPayment === (totalProductPrice - this.discountTotal- this.rebate_value)) {
					resolve()
				} else {
					reject()
				}
			});
		},
		addSales() {
			if (this.$refs.formSRE.validate() && this.productsSelected.length > 0) {
				this.checkPaymentValue().then( () => {
					this.$refs.modalconfirmAddRetail.setMessage('Apakah Anda yakin akan memproses transaksi ini?')
					this.$refs.modalconfirmAddRetail.showConfirm()
				}).catch(() => {
					this.setSnackbar({
						show: true,
						color: 'red darken-2',
						text: 'Total pembayaran yang anda masukan tidak sesuai'
					})
				})
			}
		},
		async proccessRetail() {
			await this.setOverlay(true)
			await this.$refs.modalconfirmAddRetail.hideConfirm()
			let product = await this.productsSelected.map( (el) => {
				return {
					product_name: el.data.product_name,
					product_id: el.data.product_id,
					product_code: el.data.product_code,
					quantity: el.data.quantity,
					price: el.data.price,
					is_serial: el.data.product_is_serial,
				}
			})
			let payment = await this.paymentSelected.map( el => {
				return {
					payment_name: el.data.text,
					payment_value: el.data.payment_value,
					payment_note: el.data.payment_note,
				}
			})
			let params = await {
				name: this.name,
				address: this.address,
				mobilephone: this.mobilephone,
				nip: this.nip,
				note: this.sre_note,
				discount_percentage: this.discount_percentage,
				discount_value: this.discountTotal,
				rebate_value: this.rebate_value,
				product: product,
				payment: payment,
			}
			await this.createSRE(params).then(() => {
				if (this.response.code == 200.) {
					this.resetForm()
				}
			})
			await this.setOverlay(false)
		},
		resetForm(){
			this.saveResponse({})
			this.productsSelected = []
			this.paymentSelected = []
			this.$refs.formSRE.resetValidation()
			this.search_value = ''
			this.nip = ''
			this.sre_note = ''
			this.name = ''
			this.address = ''
			this.mobilephone = ''
			this.discount_percentage = 0
		}
	},
	created() {
		this.$store.dispatch('setPageTitle', `Penjualan Langsung`)
		this.getOptionProduct({limit:100})
		this.getOptionPaymentMethod()
	},
	beforeDestroy(){
		this.clearDataSRE()
	},
	watch: {
		search_value() {
			if (this.search_value) {
				this.nip = this.search_value.mid
				this.name = this.search_value.name
				this.mobilephone = '0'+ this.search_value.mobilephone
				this.address = this.search_value.address
			} else {
				this.nip = ''
				this.name = ''
				this.mobilephone = ''
				this.address = ''
			}
		},
	}
}
</script>